import EventLogSlice from '../../src/slices/eventLogSlice';
import batchACLSlice from '../slices/batchACLSlice';
import cameraACLSlice from '../../src/slices/cameraACLSlice';
import cameraSlice from '../slices/videoSensorSlice';
import { combineReducers } from '@reduxjs/toolkit';
import crossAgencySlice from '../../src/slices/crossAgencySlice';
import heartbeatSlice from '../slices/heartbeatSlice';
import liveViewSlice from '../../src/slices/liveViewSlice';
import liveviewCameraSlice from '../../src/slices/liveviewCameraSlice';
import mapSlice from '../../src/slices/mapSlice';
import messagingChannelSlice from 'src/slices/messagingChannelSlice';
import pageNotificationSlice from '../slices/pageNotificationSlice';
import presetSlice from '../../src/slices/presetSlice';
import recordingFileSlice from '../slices/recordingFileSlice';
import recordingsSlice from '../slices/recordingSlice';
import settingSlice from '../../src/slices/settingSlice';
import streamErrorSlice from '../../src/slices/streamErrorSlice';
import superAdminSlice from '../../src/slices/superAdminSlice';
import userGroupSlice from '../../src/slices/userGroupSlice';
import userSessionSlice from 'src/slices/userSessionSlice';
import userSlice from '../../src/slices/userSlice';
import videoSensorGroupSlice from '../../src/slices/videoSensorGroupSlice';
import videoStatusSlice from '../../src/slices/videoStatusSlice';

const rootReducer = combineReducers({
  liveView: liveViewSlice,
  liveviewCamera: liveviewCameraSlice,
  camera: cameraSlice,
  userGroup: userGroupSlice,
  user: userSlice,
  cameraACL: cameraACLSlice,
  videoSensorGroup: videoSensorGroupSlice,
  map: mapSlice,
  eventLog: EventLogSlice,
  setting: settingSlice,
  preset: presetSlice,
  pageNotification: pageNotificationSlice,
  superAdmin: superAdminSlice,
  recording: recordingsSlice,
  recordingFiles: recordingFileSlice,
  messagingChannel: messagingChannelSlice,
  crossAgency: crossAgencySlice,
  videoStatus: videoStatusSlice,
  batchACL: batchACLSlice,
  userSession: userSessionSlice,
  heartbeat: heartbeatSlice,
  streamError: streamErrorSlice
});

export default rootReducer;
